import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import { Select, Spin } from "antd";

import CommonFooter from "../../../../../../core/common/footer/commonFooter";
// import Search from "antd/es/input/Search";
import Table from "../../../../../../core/pagination/datatable";
import dayjs from "dayjs";

import Swal from "sweetalert2";
import axios from "axios";
import { BASE_CRM_URL } from "../../../../../components/config/config";

const CreditNotesTab = () => {
  const { id } = useParams();

  const formatValue = (text) => {
    if (text === null || text === undefined || text === "") {
      return "-";
    }

    return text.toString().length > 15
      ? `${text.toString().substring(0, 15)}...`
      : text.toString();
  };

  const [creditNoteStatusOptions, setCreditNoteStatusOptions] = useState([]);

  const getCreditNoteStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}creditnotes/GetCreditNoteStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.CreditNoteStatus,
        }));

        setCreditNoteStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "credit_note_number",
      sorter: (a, b) =>
        (a.credit_note_number || "").localeCompare(b.credit_note_number || ""),
      render: (text, record) => (
        <Link to={`/crm/view/creditnote`} state={{ record }}>
          {formatValue(text)}
        </Link>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      render: (text) => (
        <>
          <i className="fa-regular fa-calendar me-2 text-primary"></i>
          {text ? dayjs(text).format("DD-MM-YYYY") : "-"}
        </>
      ),
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      render: (text) => (
        <>
          <i className="fa-regular fa-user me-2 text-info"></i>
          <span title={text || "-"}>
            {text
              ? text.length > 30
                ? `${text.substring(0, 30)}...`
                : text
              : "-"}
          </span>
        </>
      ),
    },
    {
      title: "Reference #",
      dataIndex: "reference_no",
      sorter: (a, b) =>
        (a.reference_no || "").localeCompare(b.reference_no || ""),
      render: (text) => formatValue(text),
    },
       {
      title: "Amount",
      dataIndex: "amount",

      render: (amount) => (
        <span className="fw-bold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
          {amount}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status_name",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Close":
              return "#dc3545";
            case "Open":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              creditNoteStatusOptions.find((item) => item.label === text)?.value
            }
            style={{ width: 100 }}
            options={creditNoteStatusOptions}
            onChange={(value) => {
              updateCreditNoteStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = creditNoteStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/creditnote`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>
            <li>
              <Link
                to={`/crm/update/creditnote/${record.id}`}
                className="dropdown-item"
                state={{
                  proposalId: record.id,
                  record,
                  type: "customer",
                }}
              >
                <Edit className="me-2 text-primary" />
                Edit
              </Link>
            </li>
          </ul> */}

           <div className="action-table-data">
            <div className="edit-delete-action ">
                 <Link
                to={`/crm/update/creditnote/${record.id}`}
                className="me-2 p-2 shadow-sm"
                state={{
                  proposalId: record.id,
                  record,
                  type: "customer",
                }}
              >
                 <i className="ti ti-pencil text-primary"></i>
            
              </Link>
              </div>
            </div>
        </>
      ),
    },
  ];

  const updateCreditNoteStatus = async (cerditId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}creditnotes/UpdateCreditNoteStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: cerditId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        getCreditNotes(id);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [customerData, setCustomerData] = useState({});
  const [creditNoteLoading, setCreditNoteLoading] = useState(false);

  const getCustomerDetails = async () => {
    try {
      setCreditNoteLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCreditNoteLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  const [creditNotes, setCreditNotes] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log(creditNotes, loading);

  const getCreditNotes = async (Id) => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}creditnotes/GetCreditNotesByCustomerId?customerId=${Id}`,
      );

      if (response.data.Status) {
        setCreditNotes(response.data.ResultData || []);
      } else {
        setCreditNotes([]);

        Swal.fire({
          title: "Warning",
          text: response.data.Message || "No creditnotes found.",
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Get creditnotes Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getCreditNotes(id);
      getCreditNoteStatuses();
    }
  }, [id]);


  return (
    <>
      <div>
        {/* <div
          className="mb-3 p-3 rounded-3 border d-flex align-items-center"
          style={{
            background: "#E8F5E9",
            borderColor: "#C8E6C9",
          }}
        >
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{
              width: "45px",
              height: "45px",
              background: "#4CAF50",
              color: "#fff",
            }}
          >
            <i className="fa-solid fa-wallet fs-4"></i>
          </div>

          <div>
            <div className="text-muted small">Available Credit Balance</div>

            <div
              className="fw-bold"
              style={{
                fontSize: "1.6rem",
                color: "#2E7D32",
                lineHeight: 1.2,
              }}
            >
              ₹1,000.00
            </div>
          </div>
        </div> */}
        <div className="card table-list-card ">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set">
          
            </div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="me-3">
                <Select
                  // defaultValue="Filter"
                  style={{ width: 180, height: 34 }}
                  prefix={<FilterOutlined />}
                  placeholder="Choose Filter..."
                  options={[
                    { value: "Filter", label: "Filter" },
                    { value: "New Filter", label: "New Filter" },
                    { value: "Working", label: "Working" },
                    { value: "Assigned To Ajith", label: "Assigned To Ajith" },
                  ]}
                />
              </div> */}

              <div className="page-btn">
                <Link
                  to="/crm/add/creditnote"
                  className="btn btn-success btn-sm me-2"
                  state={{
                    type: "customer",
                    customerId: customerData.customerId,
                    record: customerData,
                  }}
                >
                  <i className="ti ti-circle-plus fs-4 "> </i>
                </Link>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              {creditNoteLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={creditNotes} />
              )}
            </div>
          </div>
        </div>

        <CommonFooter />
      </div>
    </>
  );
};

export default CreditNotesTab;
